// extracted by mini-css-extract-plugin
export default {"genericCard":"fq-z","inline":"gq-z","mastercard":"hq-z","discover":"iq-z","visa":"jq-z","amex":"kq-z","active":"lq-z"};